import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const positions = [
  "Assistant Vice-President - Sales",
  "Sales Manager",
  "Assistant Sales Manager",
  "Closing Manager",
  "Content Writer",
  "Digital Marketing Manager",
  "Pre-sales Executive"
];

const CareerPage = () => {
  const [selectedPosition, setSelectedPosition] = useState('');
  const [resumeName, setResumeName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData(e.target);

    try {
      const response = await fetch('/backend/submit.php', {
        method: 'POST',
        body: formData,
      });

      if (response.redirected) {
        window.location.href = response.url;
      } else {
        alert('Submission failed. Please try again.');
        setIsSubmitting(false);
      }
    } catch (err) {
      console.error('Error:', err);
      alert('An error occurred while submitting.');
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header />
      <main className="bg-white">
        {/* Hero Section */}
        <section className="relative bg-propweb-800 text-white overflow-hidden min-h-[300px] md:min-h-[700px]">
          <div className="absolute inset-0">
            <img
              src="assets/PRIMA 2.webp"
              alt="Team at work"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent"></div>
          </div>
          <div className="absolute inset-x-0 bottom-0 md:bottom-16 z-10 text-center p-6">
            <h1 className="text-2xl sm:text-4xl md:text-5xl font-bold drop-shadow-lg">
              Join Our Team of Visionaries
            </h1>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-16 px-4 sm:px-6 lg:px-16 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Left: Image */}
          <div className="w-full h-96 md:h-auto">
            <img
              src="assets/hiring.jpg"
              alt="REALATION Team"
              className="w-full h-full object-cover rounded-lg shadow"
            />
          </div>

          {/* Right: Application Form */}
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-[#741112] mb-6">
              Fill This Form & Upload Your Resume
            </h2>
            <form
              onSubmit={handleSubmit}
              encType="multipart/form-data"
              className="space-y-6"
            >
              <input type="hidden" name="form_type" value="career" />

              <input
                type="text"
                name="name"
                placeholder="Name*"
                required
                className="w-full border border-gray-300 rounded px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#741112]"
              />
              <input
                type="tel"
                name="phone"
                placeholder="Number*"
                required
                className="w-full border border-gray-300 rounded px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#741112]"
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                className="w-full border border-gray-300 rounded px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#741112]"
              />

              <select
                name="position"
                value={selectedPosition}
                onChange={(e) => setSelectedPosition(e.target.value)}
                required
                className="w-full border border-gray-300 rounded px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#741112]"
              >
                <option value="">Select Position You Applied For*</option>
                {positions.map((pos, idx) => (
                  <option key={idx} value={pos}>{pos}</option>
                ))}
              </select>

              <div>
                <label className="block text-gray-700 mb-2">Submit Your Resume</label>
                <input
                  type="file"
                  name="resume"
                  accept=".pdf,.doc,.docx"
                  required
                  onChange={(e) =>
                    setResumeName(e.target.files.length ? e.target.files[0].name : '')
                  }
                  className="w-full border border-gray-300 rounded px-4 py-3"
                />
                {resumeName && (
                  <p className="mt-2 text-sm text-gray-600">
                    Resume Selected: <strong>{resumeName}</strong>
                  </p>
                )}
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className={`w-full flex items-center justify-center gap-2 bg-[#741112] text-white px-6 py-3 rounded font-semibold transition ${
                  isSubmitting ? 'opacity-60 cursor-not-allowed' : 'hover:bg-[#5c0e0f]'
                }`}
              >
                {isSubmitting && (
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v8H4z"
                    />
                  </svg>
                )}
                {isSubmitting ? 'Submitting...' : 'SUBMIT'}
              </button>
            </form>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default CareerPage;
